import { useEffect } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { getQuestionFields } from '../thunks/question-thunks';

export const useQuestionFields = () => {
  const dispatch = useDispatch();
  const { fields } = useSelector((state: RootStateOrAny) => state.question);

  useEffect(() => {
    dispatch(getQuestionFields());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { fields };
};
